import {Builder} from '../string';
import {isAgentPublisher} from './isAgentPublisher';

export const getAgentPlace = (agent: unknown): string | undefined =>
  isAgentPublisher(agent)
    ? new Builder(agent.place).add(', ', agent.country).value
    : undefined;
